module.exports = __webpack_public_path__ + "static/media/TeamMembers.9e9e4cda.png";